// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "06b84ed5a89e465d54b2b039f0578ae7" + ".js";
};